"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _gbp = _interopRequireDefault(require("gbp"));
var _table = _interopRequireDefault(require("../../../../core/table"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("div", {
  className: "card-header"
}, /*#__PURE__*/_react.default.createElement("h3", null, "Estimated Levies"));
var _ref2 = /*#__PURE__*/_react.default.createElement("th", null, "Total Estimated");
class Levies extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_getDefaultLevy", tierRef => {
      const defaultTier = this.props.defaultTiersByYear.filter(tier => tier.tierRef === tierRef);
      if (!defaultTier || !defaultTier.length) return 0;
      return defaultTier[0].levy;
    });
    _defineProperty(this, "_getNumberOfEntries", competitionDivisionID => {
      const entries = this.props.competition.completedEntries.filter(entry => entry.competitionDivisionID === competitionDivisionID);
      return entries.length;
    });
  }
  render() {
    let totalLevies = 0;
    const divisions = this.props.competition.competitionDivisions.map(div => {
      const numberOfEntries = this._getNumberOfEntries(div.id);
      const defaultLevy = this._getDefaultLevy(div.tierRef);
      const levies = defaultLevy * numberOfEntries;
      totalLevies += levies;
      return {
        ...div,
        numberOfEntries,
        defaultLevy,
        levies
      };
    });
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: "card"
    }, _ref, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block"
    }, /*#__PURE__*/_react.default.createElement(_table.default, null, /*#__PURE__*/_react.default.createElement("tbody", null, divisions.map(div => /*#__PURE__*/_react.default.createElement("tr", {
      key: div.id
    }, /*#__PURE__*/_react.default.createElement("td", null, div.description, !div.defaultLevy ? null : ' (' + (0, _gbp.default)(div.defaultLevy) + ')'), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, !div.defaultLevy ? 'N/A' : (0, _gbp.default)(div.levies)))), /*#__PURE__*/_react.default.createElement("tr", null, _ref2, /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right"
    }, (0, _gbp.default)(totalLevies))))))));
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************

  // the partialQueries and the summarisePayments function from this component are also used
  // in the statistics/finance-summary component
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(Levies, "partialQueries", {
  Competition: {
    completedEntries: {
      competitionDivisionID: true
    },
    competitionDivisions: {
      id: true,
      tierRef: true,
      description: true
    }
  },
  DefaultTiersByYear: {
    tierRef: true,
    levy: true
  }
});
var _default = exports.default = (0, _reactBicycle.connect)(Levies);